/* eslint-disable import/prefer-default-export */
import { Card } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
    border: nonergb(242, 242, 242);
    background-color: #fafafa;
`;
